import { produce } from 'immer';
import {
  FETCH_SKU_LIST_SEARCH,
  FETCH_SKU_LIST_SEARCH_FULFILLED,
  FETCH_SKU_LIST_SEARCH_REJECTED,
} from 'b2b-apps/shop/catalog/redux/skuList/actionTypes';
import {
  SkuListSearchActions,
  SkuListSearchState,
} from 'b2b-apps/shop/catalog/redux/skuList/types';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
const initialState: SkuListSearchState = {};

const reducer = (
  state: SkuListSearchState = initialState,
  action: SkuListSearchActions,
): SkuListSearchState => {
  switch (action.type) {
    case FETCH_SKU_LIST_SEARCH:
      return produce(state, (draft: SkuListSearchState) => {
        const { queryId } = action.payload;
        draft[queryId] = Object.assign(RemoteRecordData.init());
      });

    case FETCH_SKU_LIST_SEARCH_FULFILLED:
      return produce(state, (draft: SkuListSearchState) => {
        const { data, queryId } = action.payload;
        draft[queryId] = Object.assign(RemoteRecordData.fulfill(data));
      });

    case FETCH_SKU_LIST_SEARCH_REJECTED:
      return produce(state, (draft: SkuListSearchState) => {
        const { queryId } = action.payload;
        const record = draft[queryId];
        draft[queryId] = Object.assign(
          RemoteRecordData.reject(action.payload.error),
          record?.data
            ? {
              data: record?.data,
            }
            : {},
        );
      });

    default:
      return state;
  }
};

export { reducer };
